<template>
  <div class="global-search-item">
    <div class="item-text">
      <div class="item-text-header">
        <div v-if="showPrefix" :class="item.page && 'item-text-prefix'">
          <span>{{ item.name }}</span>
          <span v-if="item.page.length">></span>
        </div>
        <span v-if="item.page" v-html="item.page"></span>
        <news-badge v-if="isNew" variant="text" />
      </div>
      <span class="item-text-description" v-html="item.description"></span>
    </div>

    <mf-icon size="16" color="cinza-d10">east</mf-icon>
  </div>
</template>
<script>
import NewsBadge from './NewsBadge.vue'
export default {
  name: 'GlobalSearchItem',
  components: {
    NewsBadge,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    showPrefix: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.global-search-item {
  padding: 10px 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .mf-icon {
    height: 16px !important;
  }
  .item-text {
    display: flex;
    flex-direction: column;
    .item-text-description {
      font-size: 12px;
      color: $cinza-l40;
    }
    .item-text-header,
    .item-text-prefix {
      .news-badge {
        margin-left: 8px;
      }
      font-size: 14px;
      display: flex;
      gap: 6px;
      color: $cinza-d10;
      .item-text-prefix {
        color: $cinza-l50;
      }
    }
  }
}
::v-deep .highlight {
  background-color: #d9ebfd;
}
</style>
